import { doc, getDoc } from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';

interface Company {
  id: string;
  name: string;
}

async function getCompanies(
  companyIds: string[]
): Promise<Company[]> {
  try {
    const db = firestore;
    const companies: Company[] = [];

    for (const id of companyIds) {
      const companyDoc = await getDoc(
        doc(db, FirestoreCollections.companies, id)
      );
      if (companyDoc.exists()) {
        companies.push({
          id,
          name: companyDoc.data().name || 'Nom inconnu',
        });
      }
    }

    return companies;
  } catch (error) {
    console.error('Erreur lors de la récupération des abonnements :', error);
    return [];
  }
}

export default getCompanies;